var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoDeleteFill1Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330 176h281v47h228v91h-60v193q-21-13-50.5-19.5T675 481q-17.85 0-40.912 4.409-23.063 4.409-39.036 8.591V391H520v135q-29 18-56.017 48.35Q436.966 604.7 422 632V391h-74v399h40q2 42 21.98 88.355Q429.96 924.711 458 957H253q-36.188 0-64.094-27.112Q161 902.775 161 866V314h-60v-91h229v-47Zm339.5 372q90.97 0 155.735 64.488Q890 676.976 890 766.553q0 90.992-64.7 154.719Q760.601 985 668.933 985q-89.498 0-152.715-63.892Q453 857.217 453 765.986q0-89.476 63.68-153.731T669.5 548ZM643 644v133l91 92 36-36-76-76.204V644h-51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoDeleteFill1Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/auto_delete_FILL1_wght700_GRAD200_opsz48.b04a21764c49346d01e4eb7d05cd68a9.svg";
export { ForwardRef as ReactComponent };